export default __webpack_public_path__ + "static/media/Screenshot (1149).fe17ce79.png";